// =============================================
// File: src/services/categoryService.js
// =============================================

import axiosInstance from './axiosConfig';

const categoryService = {
  // Get all categories
  getCategories: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/categories', { params });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get single category by ID
  getCategoryById: async (id) => {
    try {
      const response = await axiosInstance.get(`/categories/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Create new category
  createCategory: async (categoryData) => {
    try {
      const response = await axiosInstance.post('/categories', categoryData,
         {
           headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update category
  updateCategory: async (id, categoryData) => {
    try {
      const response = await axiosInstance.put(`/categories/${id}`, categoryData,

        {
           headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Delete category
  deleteCategory: async (id) => {
    try {
      const response = await axiosInstance.delete(`/categories/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get products by category
  getProductsByCategory: async (categoryId, params = {}) => {
    try {
      const response = await axiosInstance.get(`/categories/${categoryId}/products`, { params });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get category tree (for nested categories)
  getCategoryTree: async () => {
    try {
      const response = await axiosInstance.get('/categories/tree');
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default categoryService;